/**
 * Created by shaun on 16/09/2017.
 */
import superagent from 'superagent';
import { v4 as uuidv4 } from 'uuid';

import AuthorisationError from 'module/error/AuthorisationError';
import ConnectionError from 'module/error/ConnectionError';
import InvalidRequest from 'module/error/InvalidRequest';
import InvalidResponse from 'module/error/InvalidResponse';
import ServerError from 'module/error/ServerError';
import queryString from "query-string";

import ApiRequest from './apiRequest';

class Common {

  httpGet(route) {
    return new ApiRequest()
      .type('get')
      .route(route)
      .init();
  }

  httpPost(route) {
    return new ApiRequest()
      .type('post')
      .route(route)
      .init();
  }

  createGuid() {
    return uuidv4();
  }

  getQueryString() {
    return queryString.parse(window.location.search);
  }

  unflattenArray(arr) {
    return arr.map((row) => {
      return this.unflattenObject(row);
    });
  }

  unflattenObject(obj) {
    let newObj = {};
    _.forEach(obj, (value, path) => {
      _.set(newObj, path, value);
    });
    return newObj;
  }

  setQueryString(newQueryString, override) {
    newQueryString = override !== true ? _.merge(this.getQueryString(), newQueryString) : newQueryString;
    history.replaceState({}, '', '?' + queryString.stringify(newQueryString) + window.location.hash);
  }

  getVuePathFromParams(routeWithParams, params) {
    return _.reduce(params, (route, value, name) => {
      return route.replace(`:${name}?`, value).replace(`:${name}`);
    }, routeWithParams);
  }

  keepElementInViewport(elementToKeep, clickEvent) {
    let top = null;
    let left = null;

    // Bottom Overflow
    if (elementToKeep && window.innerHeight < elementToKeep.getBoundingClientRect().bottom) {
      top = clickEvent.y - (elementToKeep.getBoundingClientRect().bottom - window.innerHeight) - 60;
    }

    // Right Overflow
    if (elementToKeep && window.innerWidth < elementToKeep.getBoundingClientRect().right) {
      left = clickEvent.x - (elementToKeep.getBoundingClientRect().right - window.innerWidth) - 60;
    }

    // Left Overflow
    if (elementToKeep && elementToKeep.getBoundingClientRect().left < 0) {
      left = clickEvent.x + elementToKeep.getBoundingClientRect().width;
    }

    if (top !== null) {
      elementToKeep.style.top = top + 'px';
    }

    if (left !== null) {
      elementToKeep.style.left = left + 'px';
    }
  }

  isElementInViewport(el) {
    if (el) {
      var rect = el.getBoundingClientRect();
      return (
        rect.top >= 0 &&
        // rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)/* && or $(window).height() */
        // rect.right <= (window.innerWidth || document.documentElement.clientWidth) /*or $(window).width() */
      );
    }
    return false;
  }

  convertCaseInArray(rows) {
    return rows.map((row) => {
      if (row instanceof Object) {
        row = this.convertCaseInObject(row);
      } else if (value instanceof Array) {
        row = this.convertCaseInArray(row);
      }
      return row;
    });
  }

  convertCaseInObject(row) {
    var newRow = {};

    Object.keys(row).forEach((key) => {
      //convert BlaDo => blaDo
      var newKey = key.substring(0, 1).toLowerCase() + key.substring(1);

      //convert ID => Id
      if (newKey.substring(newKey.length - 2) === 'ID') {
        newKey = newKey.substring(0, newKey.length - 2) + 'Id'
      }

      var value = row[key];

      if (value instanceof Object) {
        value = this.convertCaseInObject(value);
      } else if (value instanceof Array) {
        value = this.convertCaseInArray(value);
      }

      newRow[newKey] = value;
    });

    return newRow;
  }

  countDecimals(value) {
    if ((value % 1) != 0) {
      return value.toString().split(".")[1].length;
    } else {
      return 0
    }
  };

  parseJwt(token) {
    const base64Url = token.split('.')[1];
    let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
  };
}

export default new Common();